<template>
  <SidebarShell>
    <template #sidebar="{ variant }">
      <ParametersSidebar :variant="variant" />
    </template>
    <slot></slot>
  </SidebarShell>
</template>
